// Generated code for Big.Entities.DocumentSoort.
// Edit _Enum.tst to change the generated output.

export enum DocumentSoort {
    anders = -1,
    aanvraagformulierAanvraagformulier = 1,
    paspoortOfIdentiteitskaart = 2,
    paspoortOfIdentiteitskaartGewaarmerkteKopie = 3,
    verblijfsvergunning = 4,
    verblijfsvergunningGewaarmerkteKopie = 5,
    digitaalUittrekselUitDiplomaregisterVanDiplomaVanBeroepsopleiding = 6,
    diplomaVanBeroepsopleiding = 7,
    diplomaVanBasisonderwijsOfVoortgezetOnderwijs = 8,
    diplomaVanBasisonderwijsOfVoortgezetOnderwijsGewaarmerkteKopie = 9,
    diplomaVanVervolgopleidingOfSpecialisatie = 10,
    diplomasupplementSyllabusOfCurriculumVanBeroepsopleiding = 11,
    verklaringVanBevoegdeAutoriteitInEERLandCertificateAccompanyingTheQualifications = 12,
    verklaringVanBevoegdeAutoriteitInEERLandCertificateOfConformity = 13,
    verklaringVanBevoegdeAutoriteitInEERLand3Uit5Verklaring = 14,
    verklaringVanBevoegdeAutoriteitInEERLandErkenningDiplomaVanBuitenEER = 15,
    certificateOfCurrentProfessionalStatusCCPS = 16,
    certificateOfCurrentProfessionalStatusCCPSMetCodeVoorOnlineVerificatie = 17,
    certificateOfNonRegistration = 18,
    certificateOfGoodConductCGC = 19,
    curriculumVitaeCV = 20,
    bewijsVanNederlandseTaalvaardigheid = 21,
    periodiekRegistratieCertificaatPRC = 22,
    bewijsstukWerkervaringWerkgeversverklaring = 23,
    bewijsstukWerkervaringArbeidscontract = 24,
    bewijsstukWerkervaringFunctiebeschrijving = 25,
    bewijsstukWerkervaringLoonstrook = 26,
    bewijsstukWerkervaringJaaropgave = 27,
    bewijsstukWerkervaringVerklaringAccountantOfAdministratiekantoor = 28,
    bewijsstukWerkervaringVerklaringOpdrachtgeverMaatschaplid = 29,
    bewijsstukWerkervaringUitdraaiUitMedischAdministratiefSysteem = 30,
    bewijsstukWerkervaringFacturenEnBankafschriften = 31,
    bewijsstukWerkervaringZorgovereenkomstOfZorgcontract = 32,
    bewijsstukWerkervaringZorgplanBijWerkervaringAlsPGBZorgverlener = 33,
    bewijsstukWerkervaringVerklaringHuisartsBijWerkervaringAlsVrijwilliger = 34,
    bewijsstukWerkervaringVrijwilligersOvereenkomst = 35,
    bewijsstukWerkervaringInschrijvingInOpleidingsregister = 36,
    bewijsstukWerkervaringGoedgekeurdPromotieonderzoeksVoorstel = 37,
    bewijsstukWerkervaringInschrijvingInProfielregisterProfielarts = 38,
    bijlageOverCompetentiesBeroepsspecifiek = 50,
    bewijsstukkenVanPraktijkervaringEnOfBeroepservaring = 51,
    verklaringVanZorginstellingTijdelijkeRegistratieInBelangVanNedVolksgezondheid = 52,
    verklaringVanZorginstellingTijdelijkeRegistratieInBelangVanSuriname = 53,
    verklaringVanZorginstellingTijdelijkeRegistratieWaarneming = 54,
    verklaringTotTerugkeerNaarLandVanHerkomstNaAfloopVanBeroepsuitoefening = 55,
    reactieOpVoorgenomenBesluit = 56
}
(DocumentSoort as any).name = 'DocumentSoort';
